import { Component, EventEmitter, Inject, OnInit, Output, Input } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { SecurityController } from '@shared/src/controllers/security/security.controller';
import { AlertService } from '@shared/src/services/alert/alert.service';
import { TruckingRouteExpandDto } from '@shared/src/dtos/trucking/TruckingRouteExpandDto';
import { TruckingController } from '@shared/src/controllers/trucking/trucking.controller';
import { TruckingShipmentPackageDto } from '@shared/src/dtos/trucking/TruckingShipmentPackageDto';
import { OptionsStripDto } from '@shared/src/dtos/maintenance/option/OptionsStripDto';
import { OptionDto } from '@shared/src/dtos/maintenance/option/OptionDto';
import { ChatController, HString } from '@shared/src/public-api';
import { TruckingShipmentDto } from '@shared/src/dtos/trucking/TruckingShipmentDto';
import { TruckingRouteExecuteActionDto } from '@shared/src/dtos/trucking/TruckingRouteExecuteActionDto';
import { TruckingRouteActions } from '@shared/src/enums/TruckingRouteActions';
import { ActionDto } from '@shared/src/dtos/maintenance/action/actionDto';
import { TruckingRouteActionConfirmDto } from '@shared/src/dtos/trucking/TruckingRouteActionConfirmDto';
import { ShipmentsPackagesTruckedsResultDto } from '@shared/src/controllers/trucking/ShipmentsPackagesTruckedsResultDto';
import { ActionsStripDto } from '@shared/src/dtos/maintenance/action/ActionsStripDto';


@Component({
	selector: 'shared-trucking-route-panel-load',
	templateUrl: './shared.trucking.route.panel.load.component.html',
	styleUrls: ['./shared.trucking.route.panel.load.component.scss']
})
export class SharedTruckingRoutePanelLoadComponent implements OnInit {

	public useIonic: boolean = false;
	public iReadonly: boolean = false;

	public searchTextGroup: string = "";
	public filterMetadata: any = {};


	@Output() clickBack = new EventEmitter<boolean>();

	constructor(
		public truckingController: TruckingController,
		public chatController: ChatController,
		public fb: FormBuilder,
		@Inject('HomeController') protected homeController: HomeController,
		@Inject("SecurityController") protected securityController: SecurityController,
		@Inject("AlertService") protected alertService: AlertService) {
		this.securityController.getStoredUserDto().subscribe(data => {
			this.iReadonly = data.isReadOnly;
		});

		if (homeController.useIonic)
			this.useIonic = homeController.useIonic();

	}


	ngOnInit(): void {
		
	}

	public _selectedRouteExpand: TruckingRouteExpandDto;
	@Input()
	public get selectedRouteExpand(): TruckingRouteExpandDto {
		return this._selectedRouteExpand;
	}
	public set selectedRouteExpand(value: TruckingRouteExpandDto) {
		if (this._selectedRouteExpand === value)
			return;
		if(value == null || (this._selectedRouteExpand != null && this._selectedRouteExpand.routeId != value.routeId))
			this.shipmentsPackagesTruckeds = null;

		this._selectedRouteExpand = value;
		this.loadData();
	}

	public hasShipmentsPacketsTrucking: boolean = false;

	public loadData(){

		this.truckingController.hasShipmentsPacketsTrucking(this.selectedRouteExpand.routeId).subscribe(data => {
			this.hasShipmentsPacketsTrucking = data;
			this.loadOptions();
			this.loadActions();
		});

	}

	public options: OptionsStripDto;
	public actualOptionId: string = "PACKAGE";
	public loadOptions() {
		if(this.selectedRouteExpand == null){
			this.options = null;
			return;
		}
			
		let result = new OptionsStripDto();
		result.add(OptionDto.build("PACKAGE", "TRUCKING.ROUTE.OPCIONS.PACKAGE.CAPTION", "TRUCKING.ROUTE.OPCIONS.PACKAGE.HELP", "", 1, -1, 1, true, false));
		result.add(OptionDto.build("SHIPMENT", "TRUCKING.ROUTE.OPCIONS.SHIPMENT.CAPTION", "TRUCKING.ROUTE.OPCIONS.SHIPMENT.HELP", "", 2, -1, 1, false, false));
		result.add(OptionDto.build("DELIVERY", "TRUCKING.ROUTE.OPCIONS.DELIVERY.CAPTION", "TRUCKING.ROUTE.OPCIONS.DELIVERY.HELP", "", 3, -1, 1, false, false));
		if(this.selectedRouteExpand.canReorderShipmentInRoute)
			result.add(OptionDto.build("ORDERSHIPMENTSINROUTE", "TRUCKING.ROUTE.OPCIONS.ORDERSHIPMENTSINROUTE.CAPTION", "TRUCKING.ROUTE.OPCIONS.ORDERSHIPMENTSINROUTE.HELP", "", 4, -1, 1, false, false));
		if(this.selectedRouteExpand.canReorderPackageInRoute)
			result.add(OptionDto.build("ORDERPACKAGESINROUTE", "TRUCKING.ROUTE.OPCIONS.ORDERPACKAGESINROUTE.CAPTION", "TRUCKING.ROUTE.OPCIONS.ORDERPACKAGESINROUTE.HELP", "", 4, -1, 1, false, false));
		
		this.actualOptionId = result.getActualSelected().optionId;
		this.options = result;
	}

	onClickOption(option: OptionDto) {
		this.actualOptionId = option.optionId;
		this.loadActions();
	}

	public actions: ActionsStripDto = new ActionsStripDto();
	loadActions() {
		let tactions: ActionsStripDto = new ActionsStripDto();

		if (this.selectedRouteExpand != null) {

			if (this.actualOptionId!='DELIVERY' && this.actualOptionId!='ORDERSHIPMENTSINROUTE' && this.actualOptionId!='ORDERPACKAGESINROUTE'){
				if (!this.selectedRouteExpand.isTrucked && !this.selectedRouteExpand.isBrokenForTrucking) 
					tactions.add(ActionDto.buildBase("BROKENROUTE", "TRUCKING.ROUTE.ACTION.BROKENROUTE.CAPTION", "TRUCKING.ROUTE.ACTION.BROKENROUTE.HELP", "", 1, -1, 1, "", "action-WARNING"));
				if (this.selectedRouteExpand.isBrokenForTrucking && !this.hasShipmentsPacketsTrucking) 
					tactions.add(ActionDto.buildBase("UNBROKENROUTE", "TRUCKING.ROUTE.ACTION.UNBROKENROUTE.CAPTION", "TRUCKING.ROUTE.ACTION.UNBROKENROUTE.HELP", "", 1, -1, 1, "", "action-GO"));
				if (this.selectedRouteExpand.isBrokenForTrucking && this.hasShipmentsPacketsTrucking) 
					tactions.add(ActionDto.buildBase("UNBROKENROUTEFORCED", "TRUCKING.ROUTE.ACTION.UNBROKENROUTEFORCED.CAPTION", "TRUCKING.ROUTE.ACTION.UNBROKENROUTEFORCED.HELP", "", 1, -1, 1, "", "action-GO"));
			}
				
		}
		this.actions = tactions;
	}
	

	public askingAction: boolean = false;
	public truckingAction: TruckingRouteActionConfirmDto;
	onClickPreAction(action: ActionDto) {

		if (action != null) {
			if (action.actionId == "BROKENROUTE") {
				this.onClickAction(action);
			} else if (action.actionId == "UNBROKENROUTE") {
				this.onClickAction(action);
			} else if (action.actionId == "UNBROKENROUTEFORCED") {
				this.truckingAction = TruckingRouteActionConfirmDto.UNBROKENROUTEFORCED(action);
				this.askingAction = true;
			}
		}

	}

	public shipmentsPackagesTruckeds: ShipmentsPackagesTruckedsResultDto;
	onClickAction(action: ActionDto) {

		this.onCloseDialog();
		
		if (this.selectedRouteExpand == null)
			return;

		if (action != null) {
			if (action.actionId == "BROKENROUTE") {

				if(this.selectedRouteExpand.isBrokenForTrucking || this.selectedRouteExpand.isTrucked)
					return;

				this.truckingController.executeAction(TruckingRouteExecuteActionDto.build(TruckingRouteActions.BrokenRoute, this.selectedRouteExpand.routeId, 0, 0)).subscribe(data => {
					this.onDoClickAction(data);
				});
				
			}else if (action.actionId == "UNBROKENROUTE") {
				if(!this.selectedRouteExpand.isBrokenForTrucking)
					return;

				this.truckingController.executeAction(TruckingRouteExecuteActionDto.build(TruckingRouteActions.UnBrokenRoute, this.selectedRouteExpand.routeId, 0, 0)).subscribe(data => {
					this.onDoClickAction(data);
				});

			}else if (action.actionId == "UNBROKENROUTEFORCED") {
				if(!this.selectedRouteExpand.isBrokenForTrucking)
					return;

				this.truckingController.unbrokenrouteforced(this.selectedRouteExpand.routeId).subscribe(data => {
					this.shipmentsPackagesTruckeds = data;
					this.onDoClickAction(true);
				});

			}
		}
	}

	onCloseDialog(){
		this.askingAction = false;
		this.shipmentsPackagesTruckeds = null;
	}

	onDoClickAction(result: boolean){
		if(result){
			this.truckingController.refreshShipmentList$.next(true);
			this.truckingController.routeChanged$.next(this.selectedRouteExpand.routeId);
		}
	}

	onClickCloseBanner(event) {
		this.shipmentsPackagesTruckeds = null;
	}
	

	public selectedPackage: TruckingShipmentPackageDto;
    onClickPackage(item: TruckingShipmentPackageDto){
        this.selectedPackage = item;
    }

	public selectedShipment: TruckingShipmentDto;
	onClickShipment(item: TruckingShipmentDto) {
		this.selectedShipment = item;
	}

	onRefreshShipmentList(value: boolean){
        if(value){
			this.truckingController.refreshShipmentList$.next(true);
        }
    }

}
